type PlainObject = Record<string, any>;

const arrayIdentity: Record<string, (item: any) => string> = {
  projects: (item) => item?.title ?? "",
  professionalCareer: (item) =>
    `${item?.Company ?? ""}|${item?.Position ?? ""}|${item?.["Employment period"] ?? ""}`,
  education: (item) => `${item?.degree ?? ""}|${item?.institution ?? ""}`,
  languages: (item) => item?.name ?? "",
  certificates: (item) => item?.name ?? "",
  tech: (item) =>
    item && typeof item === "object" ? Object.keys(item)[0] ?? "" : String(item),
  headlines: (item) => String(item),
  certificates_logos: (item) => String(item),
};

export function canonicalizeKeys(value: any, preferredOrder?: string[]): any {
  if (Array.isArray(value)) {
    return value.map((item) => canonicalizeKeys(item));
  }

  if (value && typeof value === "object") {
    const keys = Object.keys(value);
    const ordered = preferredOrder
      ? [
          ...preferredOrder.filter((key) => keys.includes(key)),
          ...keys.filter((key) => !preferredOrder.includes(key)).sort(),
        ]
      : [...keys].sort();

    const result: PlainObject = {};
    for (const key of ordered) {
      result[key] = canonicalizeKeys(value[key]);
    }
    return result;
  }

  return value;
}

export function alignArraysToReference(
  reference: PlainObject,
  target: PlainObject
): PlainObject {
  const aligned: PlainObject = { ...reference };

  for (const [field, identity] of Object.entries(arrayIdentity)) {
    const referenceArray = reference?.[field];
    const targetArray = target?.[field];
    if (!Array.isArray(referenceArray) || !Array.isArray(targetArray)) continue;

    const targetRank = new Map<string, number>();
    targetArray.forEach((item, index) => {
      const key = identity(item);
      if (!targetRank.has(key)) targetRank.set(key, index);
    });

    aligned[field] = referenceArray
      .map((item, index) => ({
        item,
        index,
        rank: targetRank.get(identity(item)) ?? Number.POSITIVE_INFINITY,
      }))
      .sort((a, b) => a.rank - b.rank || a.index - b.index)
      .map((entry) => entry.item);
  }

  return aligned;
}
